import { TExtendedCollectionRankingEntry } from '@lootboy/lib/slices/cardCollections/types';

export const NUMBER_OF_TOP_ENTRIES = 5;

export function splitTopIntoPodiumAnRest(
  top: Array<TExtendedCollectionRankingEntry>,
): {
  podium: Array<TExtendedCollectionRankingEntry>;
  rest: Array<TExtendedCollectionRankingEntry>;
} {
  const podium = [...top];

  const firstEntryOfRest = podium.findIndex((entry) => entry.no > 3);
  const rest = firstEntryOfRest === -1 ? [] : podium.splice(firstEntryOfRest);

  return {
    podium,
    rest,
  };
}
